module.exports = __webpack_public_path__ + "img/nav-06.ef80c25b.jpg";